/**
 * @fileoverview GET handler for the "/engagement/segments/campaigns_for_link_segmentation" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsCampaignsForLinkSegmentation } from "./constants";
import type { EngagementSegmentsCampaignsForLinkSegmentationResult } from "./types";

export const getEngagementSegmentsCampaignsForLinkSegmentation = reactQueryFetcherAdapter(
  engagementSegmentsCampaignsForLinkSegmentation,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number
  ): Promise<EngagementSegmentsCampaignsForLinkSegmentationResult[]> => {
    return fetch(
      "/engagement/segments/campaigns_for_link_segmentation",
      "GET",
      { app_group_id: appGroupId, query, limit },
      { signal }
    );
  }
);
